import { useEffect } from "react";
import { useSettings } from "@/context/SettingsContext";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
  el.setAttribute("content", content);
}
function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
  el.setAttribute("href", href);
}
function injectJsonLd(id, obj) {
  let el = document.getElementById(id);
  if (obj == null) { if (el) el.remove(); return; }
  if (!el) { el = document.createElement("script"); el.id = id; el.type = "application/ld+json"; document.head.appendChild(el); }
  el.textContent = JSON.stringify(obj);
}

export default function Seo({ title, description, schema, image }) {
  const { settings } = useSettings();
  useEffect(() => {
    const t = title ? `${title} | ${settings.site_name || "ADNEXA DIGITAL"}` : (settings.seo_title || "ADNEXA DIGITAL");
    const d = description || settings.seo_description || "";
    const img = image || `${window.location.origin}/adnexa-logo.png`;
    document.title = t;
    setMeta("description", d);
    setMeta("og:title", t, "property");
    setMeta("og:description", d, "property");
    setMeta("og:image", img, "property");
    setMeta("twitter:card", "summary_large_image");
    setCanonical(window.location.href.split("?")[0]);
    injectJsonLd("ld-org", {
      "@context": "https://schema.org", "@type": "Organization",
      name: settings.site_name || "ADNEXA DIGITAL", url: window.location.origin,
      description: settings.seo_description || "", logo: `${window.location.origin}/adnexa-logo.png`,
      sameAs: [settings.instagram, settings.facebook, settings.linkedin, settings.twitter].filter(Boolean),
    });
    injectJsonLd("ld-page", schema || null);
  }, [title, description, schema, image, settings]);
  return null;
}
